import {
    List,
    Datagrid,
    TextField as TextFieldRa,
    Create,
    SimpleForm,
    TextInput,
    EditButton,
    Show,
    Edit,
    Filter,
    ShowButton,
    BooleanField,
    BooleanInput,
    DateInput,
    DeleteButton,
} from 'react-admin'

import CardGiftcardTwoToneIcon from '@mui/icons-material/CardGiftcardTwoTone';

export const PromotionIcon = CardGiftcardTwoToneIcon


const PromotionFilter = props => (
    <Filter {...props}>
        {/* <SearchInput source="q" alwaysOn /> */}
        <TextInput label="Id" source="id" />
        <DateInput source="startDate" placeholder="Início" alwaysOn />
        <DateInput source="endDate" placeholder="Término" alwaysOn />
    </Filter>
)

export const PromotionList = (props) => {
    return (<>
        <List
            {...props}
            exporter={false}
            title="Promoções"
            bulkActionButtons={false}
            sort={{ field: 'id', order: 'DESC' }}
            filters={<PromotionFilter />}
        >
            <Datagrid>
                <TextFieldRa source="id" label="ID" />
                <TextFieldRa source="title" label="Título" />
                <TextFieldRa source="couponDescription" label="Descrição do Cupom" />
                <TextFieldRa source="couponCode" label="Código do Cupom" />
                <TextFieldRa
                    source="startDate"
                    label="Data de Início"
                />
                <TextFieldRa
                    source="endDate"
                    label="Data de Fim"
                />
                <TextFieldRa source="theme" label="Tema" />
                <TextFieldRa source="leadTitle" label="Título do Lead" />

                <EditButton label="" />
                <ShowButton label="" />
                <DeleteButton label='' />
            </Datagrid>
        </List>
    </>
    )
}

export const PromotionCreate = (props) => {
    return (<>
        <Create {...props}>
            <SimpleForm redirect="list">
                <TextInput source="title" label="Título" />
                <TextInput source="subtitle" label="Subtítulo" />
                <TextInput source="couponDescription" label="Descrição do Cupom" />
                <TextInput source="couponCode" label="Código do Cupom" />
                <DateInput source="startDate" label="Data de Início" />
                <DateInput source="endDate" label="Data de Fim" />
                <BooleanInput source="isDefault" label="Padrão" />
                <BooleanInput source="isTemplate" label="É Template?" />
                <BooleanInput source="showText" label="Exibir Texto" />
                <BooleanInput source="showCoupon" label="Exibir Cupom" />
                <TextInput source="background" label="Imagem de Fundo (Desktop)" />
                <TextInput source="mobileImage" label="Imagem de Fundo (Mobile)" />
                <TextInput source="backgroundColor" label="Cor de Fundo" />
                <TextInput source="theme" label="Tema" />
                <TextInput source="leadTitle" label="Título do Lead" />
                <TextInput source="counterLabel" label="Etiqueta Contador" />
                <BooleanInput source="counterDisplay" label="Exibe Contador" />
            </SimpleForm>
        </Create>
    </>)
}

export const PromotionEdit = (props) => {
    return (
        <Edit {...props}>
            <SimpleForm redirect="list">
                <TextInput source="title" label="Título" />
                <TextInput source="subtitle" label="Subtítulo" />
                <TextInput source="couponDescription" label="Descrição do Cupom" />
                <TextInput source="couponCode" label="Código do Cupom" />
                <TextInput source="startDate" label="Data de Início" />
                <TextInput source="endDate" label="Data de Fim" />
                <BooleanInput source="isDefault" label="Padrão" />
                <BooleanInput source="isTemplate" label="É Template?" />
                <BooleanInput source="showText" label="Exibir Texto" />
                <BooleanInput source="showCoupon" label="Exibir Cupom" />
                <TextInput source="background" label="Imagem de Fundo (Desktop)" />
                <TextInput source="mobileImage" label="Imagem de Fundo (Mobile)" />
                <TextInput source="backgroundColor" label="Cor de Fundo" />
                <TextInput source="theme" label="Tema" />
                <TextInput source="leadTitle" label="Título do Lead" />
                <TextInput source="counterLabel" label="Etiqueta Contador" />
                <BooleanInput source="counterDisplay" label="Exibe Contador" />
            </SimpleForm>
        </Edit>
    )
}

export const PromotionShow = (props) => {
    const listItemStyle = {
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        padding: "8px 0",
        borderBottom: "1px solid #eee",
        gap: "5px"
    };

    const labelStyle = {
        fontWeight: "600",
        color: "#555",
        minWidth: "160px",
    };

    const valueStyle = {
        flex: 1,
        color: "#333",
    };

    const sectionTitleStyle = {
        fontWeight: "700",
        fontSize: "20px",
        color: "#444",
        marginBottom: "18px",
        borderBottom: "1px solid #ddd",
        paddingBottom: "6px",
    };

    return (
        <Show {...props}>
            <div
                style={{
                    maxWidth: "600px",
                    margin: "40px auto",
                    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                    padding: "24px 32px",
                    color: "#444",
                }}
            >
                <h2
                    style={{
                        fontWeight: "700",
                        fontSize: "28px",
                        marginBottom: "36px",
                        borderBottom: "2px solid #ddd",
                        paddingBottom: "10px",
                        color: "#222",
                    }}
                >
                    Detalhes da Promoção
                </h2>

                {/* Informações Básicas */}
                <section style={{ marginBottom: "36px" }}>
                    <h3 style={sectionTitleStyle}>Informações Básicas</h3>
                    <ul style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>ID</span>
                            <TextFieldRa source="id" style={valueStyle} />
                        </li>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>Título</span>
                            <TextFieldRa source="title" style={valueStyle} />
                        </li>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>Subtítulo</span>
                            <TextFieldRa source="subtitle" style={valueStyle} />
                        </li>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>Tema</span>
                            <TextFieldRa source="theme" style={valueStyle} />
                        </li>
                    </ul>
                </section>

                {/* Detalhes do Cupom */}
                <section style={{ marginBottom: "36px" }}>
                    <h3 style={sectionTitleStyle}>Detalhes do Cupom</h3>
                    <ul style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>Descrição do Cupom</span>
                            <TextFieldRa source="couponDescription" style={valueStyle} />
                        </li>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>Código do Cupom</span>
                            <TextFieldRa source="couponCode" style={valueStyle} />
                        </li>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>Exibir Cupom</span>
                            <BooleanField source="showCoupon" style={valueStyle} />
                        </li>
                    </ul>
                </section>

                {/* Períodos */}
                <section style={{ marginBottom: "36px" }}>
                    <h3 style={sectionTitleStyle}>Períodos</h3>
                    <ul style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>Data de Início</span>
                            <TextFieldRa source="startDate" style={valueStyle} />
                        </li>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>Data de Fim</span>
                            <TextFieldRa source="endDate" style={valueStyle} />
                        </li>
                    </ul>
                </section>

                {/* Configurações de Visibilidade */}
                <section style={{ marginBottom: "36px" }}>
                    <h3 style={sectionTitleStyle}>Configurações de Visibilidade</h3>
                    <ul style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>Padrão</span>
                            <BooleanField source="isDefault" style={valueStyle} />
                        </li>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>É Template?</span>
                            <BooleanField source="isTemplate" style={valueStyle} />
                        </li>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>Exibir Texto</span>
                            <BooleanField source="showText" style={valueStyle} />
                        </li>
                    </ul>
                </section>

                {/* Estilo Visual */}
                <section style={{ marginBottom: "36px" }}>
                    <h3 style={sectionTitleStyle}>Estilo Visual</h3>
                    <ul style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>Cor de Fundo</span>
                            <TextFieldRa source="backgroundColor" style={valueStyle} />
                        </li>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>Imagem de Fundo (Desktop):   </span>
                            <TextFieldRa source="background" style={valueStyle} />
                        </li>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>Imagem de Fundo (Mobile): </span>
                            <TextFieldRa source="mobileImage" style={valueStyle} />
                        </li>
                    </ul>
                </section>

                {/* Conteúdo do Lead */}
                <section style={{ marginBottom: "36px" }}>
                    <h3 style={sectionTitleStyle}>Conteúdo do Lead</h3>
                    <ul style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>Título do Lead</span>
                            <TextFieldRa source="leadTitle" style={valueStyle} />
                        </li>
                    </ul>
                </section>

                {/* Conteúdo do Contador */}
                <section style={{ marginBottom: "36px" }}>
                    <h3 style={sectionTitleStyle}>Conteúdo do Contador</h3>
                    <ul style={{ listStyle: "none", paddingLeft: 0, margin: 0 }}>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>Etiqueta Contador</span>
                            <TextFieldRa source="counterLabel" style={valueStyle} />
                        </li>
                        <li style={listItemStyle}>
                            <span style={labelStyle}>Exibe Contador</span>
                            <BooleanField source="counterDisplay" style={valueStyle} />
                        </li>
                    </ul>
                </section>
            </div>
        </Show>
    );
};